export enum OfferState {
  DENIED = 'DENIED',
  SUSPENDED = 'SUSPENDED',
  PULLED = 'PULLED',
  PENDING = 'PENDING',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  ACCEPTED = 'ACCEPTED',
  EXPIRED = 'EXPIRED',
}
